import { request } from "utils/api";
import { RequestResponse } from "utils/base_api";

export function create(attributes): Promise<RequestResponse> {
  return request("/question_aid_ratings", { method: "POST", body: attributes });
}

export function update(attributes): Promise<RequestResponse> {
  return request("/question_aid_ratings", {
    method: "PATCH",
    body: attributes
  });
}

export function getByQuestionId(questionId: number): Promise<RequestResponse> {
  return request(`/question_aid_ratings/${questionId}`, { method: "GET" });
}
